import { useState } from "react";
import { Card, Flex, Button, Text, Heading } from "@radix-ui/themes";
import { UploadIcon, CheckCircledIcon } from "@radix-ui/react-icons";
import toast from "react-hot-toast";
import { post, postFormData } from "../../utils/axios-config";
import { UPLOAD_IMAGES } from "../../utils/constants";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { UploadImagesFormValidation } from "./UploadImagesFormValidation";
import { UploadItem } from "./UploadItem";





const UploadImages = () => {
  const [uploads] = useState<{ type: any }[]>([
    {
      type: "favicon",
    },
    {
      type: "logo",
    },
    {
      type: "background",
    },
  ]);
  return (
    <>
      <div style={{ padding: "24px", maxWidth: "1200px" }}>
        <Text color="gray" size="2" mb="4">
          Faça upload das imagens que serão utilizadas no sistema
        </Text>
        {uploads.map((item, index) => (
          <UploadItem type={item.type} key={index} />
        ))}
      </div>
    </>
  );
};

export default UploadImages;
